<template>
  <div class="relative w-full z-50">
    <!-- Dropdown List -->
    <ul
        v-if="hospitalTags.length > 0"
        class="w-full bg-white border rounded mt-1 max-h-48 overflow-y-auto shadow-lg z-50"
    >
      <li
          v-for="tag in hospitalTags"
          :key="tag.id"
          class="p-2 flex items-center space-x-2 hover:bg-gray-100 cursor-pointer"
          @click="toggleSelection(tag)"
      >
        <input
            type="checkbox"
            :checked="selectedTags.includes(tag.name)"
            class="cursor-pointer"
        />
        <span>{{ tag.name }}</span>
      </li>
    </ul>

    <!-- Loading Indicator -->
    <div
        v-else-if="isLoading"
        class="w-full p-2 text-center text-gray-500"
    >
      Loading tags...
    </div>

    <!-- No Results -->
    <div v-else class="w-full p-2 text-center text-gray-500">
      No tags found.
    </div>
  </div>
</template>

<script>
import {useHospitalsStore} from "@/store/hospitals";

export default {
  name: "TagsEditor",
  props: ['params'],
  data() {
    return {
      searchTerm: "", // Local search term
      selectedTags: this.params.value.split(","), // Start with the current value
      hospitalTags: [], // Tags for the given hospital
      isLoading: true, // Loading state
      hospitalsStore: useHospitalsStore(),
    };
  },
  methods: {
    getValue() {
      return this.selectedTags.filter((tagLabel) => this.hospitalTags.find((tag) => tag.name === tagLabel) !== undefined).join(",");
    },
    isPopup() {
      return true;
    },
    async loadTags() {
      this.isLoading = true;
      try {
        const hospital = this.hospitalsStore.hospitals.find(
            (h) => h.hospital_id === this.params.hospitalId
        );
        if (hospital) {
          this.hospitalTags = hospital.hospital_tags || [];
        } else {
          console.warn(`Hospital with ID ${this.hospitalId} not found.`);
          this.hospitalTags = [];
        }
      } catch (error) {
        console.error("Error loading hospital tags:", error);
        this.hospitalTags = [];
      } finally {
        this.isLoading = false;
      }
    },
    toggleSelection(tag) {
      const index = this.selectedTags.indexOf(tag.name);
      if (index > -1) {
        this.selectedTags.splice(index, 1); // Remove if already selected
      } else {
        this.selectedTags.push(tag.name); // Add if not selected
      }
    },
  },
  watch: {
    "params.hospitalId": {
      immediate: true,
      handler() {
        this.loadTags(); // Load tags whenever the hospital ID changes
      },
    },
  },
};
</script>

<style scoped>
/* Add any additional styles to improve dropdown appearance */
</style>
